const flags = ["packages2.0", "login2.0", "loyalty-points", "appbar2.0", "klienci2.0"] as const;
export type FeatureFlag = (typeof flags)[number];

export const featureFlags = {
  enabled(flag: FeatureFlag) {
    return !!localStorage.getItem(flag);
  },
  admin: {
    list(): Record<FeatureFlag, boolean> {
      return flags.reduce(
        (acc, it) => ({ ...acc, [it]: featureFlags.enabled(it) }),
        {} as Record<FeatureFlag, boolean>,
      );
    },
    disable(flag: FeatureFlag) {
      localStorage.removeItem(flag);
    },
    enable(flag: FeatureFlag) {
      localStorage.setItem(flag, "true");
    },
  },
};
